export enum SubscriptionStatusHistoryStateEnum {
  AWAITING = 'AWAITING',
  APPLIED = 'APPLIED',
  ERROR = 'ERROR'
}